/* eslint-disable quotes */
import './index.scss';
import { utility, Dialog } from '@phi/components';
import { defineComponent, h } from 'vue';
import { execute_scale } from '..';

const rescale_model_guide = 'img/rescale_model_guide.webp';

const body = `<div class='scale-image-container ${utility.no_interact_with_children}'>
    <img class='scale-image' id='rescale_model_guide_png' width='240' id='rescale-model-guide' src=${rescale_model_guide} loading='lazy'/>
</div>

<table>
    <tr class='scale-table__row'>
        <th></th>
        <th>Current (<span id='scale_unit_current' class='unit'></span>)</th>
        <th>New (<span id='scale_unit_new' class='unit'></span>)</th>
        <th>%</th>
    </tr>

    <tr id = 'scale-table_d_row'>
        <td class='label'>D:</td>

        <td>
            <input type='text' class='form-control' size='6' readonly
                id='scale-d-current-distance-text' autocomplete='off'>
        </td>

        <td>
            <input type='number' class='rescale-model form-control' id='scale-d-new-distance-text'
                step='1' size='6' autocomplete='off'>
        </td>

        <td>
            <input type='number' class='rescale-percentage form-control' id='scale-percentage-d'
                step='1' size='3' value='100' autocomplete='off'>
        </td>
    </tr>

    <tr id = 'scale-table_x_row'>
        <td class='label' id = 'scale-table_x_label'>X:</td>

        <td>
            <input type='text' class='form-control' size='6' readonly
                id='scale-x-current-distance-text' autocomplete='off'>
        </td>

        <td>
            <input type='number' class='rescale-model form-control' id='scale-x-new-distance-text'
                step='1' size='6' autocomplete='off'>
        </td>

        <td>
            <input type='number' class='rescale-percentage form-control' id='scale-percentage-x'
                step='1' size='3' value='100' autocomplete='off'>
        </div>
    </tr>

    <tr id = 'scale-table_y_row'>
        <td class='label' id = 'scale-table_y_label'>Y:</td>

        <td>
            <input type='text' class='form-control' size='6' readonly
                id='scale-y-current-distance-text' autocomplete='off'>
        </td>

        <td>
            <input type='number' class='rescale-model form-control' id='scale-y-new-distance-text'
                step='1' size='6' autocomplete='off'>
        </td>

        <td>
            <input type='number' class='rescale-percentage form-control' id='scale-percentage-y'
                step='1' size='3' value='100' autocomplete='off'>
        </td>
    </tr>

    <tr id = 'scale-table_z_row'>
        <td class='label'  id = 'scale-table_z_label'>Z:</td>

        <td>
            <input type='text' class='form-control' size='6' readonly
                id='scale-z-current-distance-text' autocomplete='off'>
        </td>
        <td>
            <input type='number' class='rescale-model form-control' id='scale-z-new-distance-text'
                step='1' size='6' autocomplete='off'>
        </td>

        <td>
            <input type='number' class='rescale-percentage form-control' id='scale-percentage-z'
                step='1' size='3' value='100' autocomplete='off'>
        </td>
    </tr>
</table>

<div class='scale-options'>
    <label for='modelProportionally' class='label label--with-checkbox'>
        <input class='form-control sr-only' type='checkbox' name='proportional'
            id='modelProportionally'>
        <div class='phi-custom-checkbox'>
            <svg class='phi-custom-checkbox__icon' width='16' height='16'>
                <use xlink:href='#arrow-check'></use>
            </svg>
        </div>
        <div class='label__text'>Rescale proportionally</div>
    </label>
    <label for='lockFirstSelected' class='label label--with-checkbox'>
        <input class='form-control sr-only' type='checkbox' name='proportional' id='lockFirstSelected'>
        <div class='phi-custom-checkbox'>
            <svg class='phi-custom-checkbox__icon' width='16' height='16'>
                <use xlink:href='#arrow-check'></use>
            </svg>
        </div>
        <div class='label__text'>Lock first selected vertex</div>
    </label>
</div>`;

export const ScaleModal = defineComponent({
    props: {
        show: { required: true, type: Boolean},
    },

    emits: {
        'update:show': (x: boolean) => true,
    },

    render() {
        return h(Dialog, {
            show: this.show,
            'onUpdate:show': x => this.$emit('update:show', x),
            onClose: () => this.$emit('update:show', false),
            confirm_label: 'Scale',
            onConfirm: () => execute_scale(),
            id: 'scaleModal',
            title: 'Scale objects',
            unload: false,
            width: 'extra-narrow',
        }, () => h('div', { innerHTML: body }));
    }
});
